// modules
import { combineReducers } from 'redux'
// reducers
import { wisesReducer } from '$logic/wises'
import { keyvalReducer } from '../lib/keyval.storage'
import wappsReducer from '../wapps/wapps.reducer'
import wappStackReducer from '../wappStack/wappStack.reducer'
import { contactsReducer } from '../contacts/storage'
import { roomsReducer } from '../room/storage'
import { hallsReducer } from '../hall/storage'
import { pvsReducer } from '../pv/storage'
import { workspaceReducer } from '../workspace/storage'
import { draftsReducer } from '../draft/storage'
import { subscriptionsReducer } from '../subscription/storage'
import { usersReducer } from '../users/storage'
import { wappRoomsReducer } from '../wapp-room/storage'
import { usersStatusReducer } from '../users/user-status.storage'
import { openedRoomReducer } from '../opened-room/opened-room.storage'
import { openedRoomMessagesReducer } from '../opened-room/opened-room-messages.storage'
import { openedUserListReducer } from '$logic/opened-user-list'
import { pendingUploadsReducer } from '$logic/pending-uploads/storage'
import { pendingMessagesReducer } from '$logic/pending-messages/storage'
import { messageActionReducer } from '$logic/message-action/message-action.storage'
import { openedRoomSharedMediaReducer } from '$logic/shared-media/opened-room-shared-media.storage'
import { authReducer } from '$logic/auth/storage'
import { roomLastMessageReducer } from '$logic/room-last-message/storage'
import { openedRoomPinnedMessagesReducer } from '$logic/pin/opened-room-storage'
import { callReducer } from '$logic/call'
import { userPermissionsReducer } from '$logic/user-permissions'
import { audioPlayerReducer } from '$logic/audio-player/storage'
import { pendingEditsReducer } from '$logic/pending-edits/storage'
import { pendingEditUploadsReducer } from '$logic/pending-edit-uploads/storage'
import { hallInviteLinksReducer } from '$logic/hall/invite-link.storage'
import { storiesReducer } from '$logic/story/storage'
import { adsReducer } from '$logic/ads/storage'
import { lastOpenedRoomMessagesReducer } from '$logic/last-opened-room-messages/storage'
import { workspaceReducer } from '$logic/workspace/storage'

export default combineReducers({
  auth: authReducer,
  pendingMessages: pendingMessagesReducer,
  pendingEdits: pendingEditsReducer,
  pendingEditUploads: pendingEditUploadsReducer,
  wapps: wappsReducer,
  wappStack: wappStackReducer,
  wises: wisesReducer,
  contacts: contactsReducer,
  keyval: keyvalReducer,
  rooms: roomsReducer,
  halls: hallsReducer,
  pvs: pvsReducer,
  drafts: draftsReducer,
  subscriptions: subscriptionsReducer,
  users: usersReducer,
  wappRooms: wappRoomsReducer,
  usersStatus: usersStatusReducer,
  openedRoom: openedRoomReducer,
  hallInviteLinks: hallInviteLinksReducer,
  openedRoomMessages: openedRoomMessagesReducer,
  openedUserList: openedUserListReducer,
  pendingUploads: pendingUploadsReducer,
  messageActions: messageActionReducer,
  openedRoomSharedMedia: openedRoomSharedMediaReducer,
  roomLastMessage: roomLastMessageReducer,
  openedRoomPinnedMessages: openedRoomPinnedMessagesReducer,
  call: callReducer,
  userPermissions: userPermissionsReducer,
  audioPlayer: audioPlayerReducer,
  story: storiesReducer,
  workspace: workspaceReducer,
  ads: adsReducer,
  lastOpenedRoomMessages: lastOpenedRoomMessagesReducer,
  workspace: workspaceReducer,
})
